import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from './ui/sonner';

export const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20">
        {children}
      </main>
      {!hideFooter && <Footer />}
      <Toaster position="top-right" richColors />
    </div>
  );
};
